import type { WorkspaceRole } from "../../state/workspaces/types";
import { GlobalAccess, type GlobalAccessType } from "./global.access";

export function globalAccessToWorkspaceRole(
  globalAccess: GlobalAccessType,
): WorkspaceRole {
  switch (globalAccess) {
    case GlobalAccess.READ:
      return "read";
    case GlobalAccess.WRITE:
      return "write";
    default:
      return "none";
  }
}
